import { IChecklistDTO } from "../../common/types";
import { GetMethod } from "../../methods/GetMethod";

export class GetChecklistByIdEndpoint extends GetMethod<IChecklistDTO> {
  constructor() {
    super(`${process.env.REACT_APP_API_URL}/checklists`);
  }
}
